<script>
	import Header from './Header.svelte';
	import Figure from './Figure.svelte';
	import Movies from './Movies.svelte';
	import Graph from './Graph.svelte';
	import Title from './Title.svelte';
	import How from './How.svelte';
	import About from './About.svelte';
	//import Figure2 from './Figure2.svelte';

	let obj = { "movie" : "2001: A Space Odyssey", "graph" : "spheres" };

	let maxWidth = "900px";

	function handleMovie(event) {
			obj.movie = event.detail.text;
		}

	function handleGraph(event) {
			obj.graph = event.detail.text;
		}

</script>

<main>
	<div class="container">
		{#key obj}
		<Title {obj} />
		{/key}

		<Movies on:message={handleMovie} />
		<Graph on:message={handleGraph} />

		{#key obj}
		<!--<Header {maxWidth} {obj} />-->
		<Figure {maxWidth} {obj} />
		<!--<Figure2 {maxWidth} {obj} />-->
		<How />
		<About />
		{/key}

		

		

	</div>
</main>

<style>
main {
		text-align: center;
		padding: 1em;
		margin: 0 auto;
}

</style>
